import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { PAGE_ROUTE_PATH, URL_PARAMS_KEY } from '@/constants';
import { useInternalRedirect } from '@/features/redirect';
import { useLoginUserInfo } from '@/hooks/useLoginUserInfo';

/**
 * リトライ失敗エラー カスタムフック
 */
export const useRetryError = () => {
  const navigate = useNavigate();
  const { isSerialPlan } = useLoginUserInfo();
  const { internalRedirectToWelcome } = useInternalRedirect();

  /**
   * リトライ失敗エラーダイアログ用OKボタンのクリック処理
   */
  const clickRetryErrorOKButton = useCallback(() => {
    if (isSerialPlan) {
      // シリアルで利用開始した場合はホーム画面に遷移
      navigate({
        pathname: PAGE_ROUTE_PATH.HOME,
      });

      return;
    }

    // ようこそ画面に遷移。このときホーム画面のパスを指定
    internalRedirectToWelcome(
      encodeURI(`${URL_PARAMS_KEY.WELCOME.path}=${PAGE_ROUTE_PATH.HOME}`),
    );
  }, [internalRedirectToWelcome, isSerialPlan, navigate]);

  return {
    clickRetryErrorOKButton,
  };
};
